import { Ref } from 'vue'

import { Event, SubParticipant } from '@collector/sportsapi-client-legacy'
import * as sportsAPI from '@mobile/globalState/sportsAPI'

export function updateSubParticipants(
  subParticipants: SubParticipant[],
  eventSubParticipantsRef: Ref<SubParticipant[]>,
): void {
  const subParticipantsMap = new Map(
    eventSubParticipantsRef.value.map((p) => [p.id, p]),
  )

  for (const sp of subParticipants) {
    const id = sp.participant_id ?? sp.id
    subParticipantsMap.set(id, { ...sp, id })
  }

  eventSubParticipantsRef.value = Array.from(subParticipantsMap.values())
}

export async function reloadEventSubParticipants(
  event: Event,
  eventSubParticipantsRef: Ref<SubParticipant[]>,
): Promise<void> {
  const response = await sportsAPI.state.client.getEventLineups(event.id)

  updateSubParticipants(
    response.api.data.sub_participants,
    eventSubParticipantsRef,
  )
}
